import React, { useState, useEffect } from 'react';
import Footer from '../../agent/Tabs/Payments/Footer';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import { Select, MenuItem } from '@material-ui/core';
import FlechaIzquierda from '../validation/arrowLeft.svg';
import { IconButton } from '@material-ui/core';
import StepBullets from '../StepBullets';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import {
  getClientsRFC,
  persistDataPolicy,
  getCustomerRFC,
  getClientsCatalog
} from '../../../redux/actions/clientActions';
import { useHistory } from 'react-router-dom';
import iconClient from '../images/iconClient.png';
import gifTooltip from '../images/gifTooltip.gif';
import { withStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import ModalUserNotFound from '../ModalUserNotFound';
import FooterMobile from '../../agent/Tabs/Payments/FooterMobile';
import { isMobile } from 'react-device-detect';
import Spinner from '../Spinner';

const CustomTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#fff',
    color: '#000',
    fontSize: '14px',
    border: '1px solid #ddd',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '5px',
    padding: '10px',
    maxWidth: '200px'
  },
  arrow: {
    color: '#ddd'
  }
}))(Tooltip);

const IdentificateUser = props => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clientType, setClientType] = useState('Fisica');
  const [formData, setFormData] = useState({
    rfc: '',
    typeinvoice: '',
    razonSocial: '',
    firstName: '',
    secondName: '',
    lastName: '',
    motherLastName: ''
  });
  const resetForm = () => {
    setFormData({
      rfc: '',
      typeinvoice: '',
      razonSocial: '',
      firstName: '',
      secondName: '',
      lastName: '',
      motherLastName: ''
    });
  };
  const [errors, setErrors] = useState({});
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    props.getClientsCatalog(props.clientToken);
  }, []);

  useEffect(() => {
    validateFields();
  }, [formData]);

  const validateRFC = (rfc, clientType) => {
    const rfcFisica = /^[A-ZÑ&]{4}\d{6}[A-Z0-9]{3}$/;
    const rfcMoral = /^[A-ZÑ&]{3}\d{6}[A-Z0-9]{3}$/;
    return clientType === 'Fisica' ? rfcFisica.test(rfc) : rfcMoral.test(rfc);
  };

  const validateFields = () => {
    const newErrors = {};
    if (!formData.rfc) {
      newErrors.rfc = 'Campo requerido';
    } else if (!validateRFC(formData.rfc, clientType)) {
      newErrors.rfc = `El RFC no cumple con el formato para ${
        clientType === 'Fisica' ? 'personas físicas' : 'personas morales'
      }`;
    }
    if (!formData.typeinvoice) newErrors.typeinvoice = 'Campo requerido';

    if (clientType === 'Moral') {
      if (!formData.razonSocial) newErrors.razonSocial = 'Campo requerido';
    } else if (clientType === 'Fisica') {
      if (!formData.firstName) {
        newErrors.firstName = 'Campo requerido';
      } else if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(formData.firstName)) {
        newErrors.firstName = 'El campo Primer nombre solo debe contener texto';
      }

      if (!formData.lastName) {
        newErrors.lastName = 'Campo requerido';
      } else if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(formData.lastName)) {
        newErrors.lastName = 'El campo Apellido Paterno solo debe contener texto';
      }

      if (!formData.motherLastName) {
        newErrors.motherLastName = 'Campo requerido';
      } else if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(formData.motherLastName)) {
        newErrors.motherLastName = 'El campo Apellido Materno solo debe contener texto';
      }
    }

    setErrors(newErrors);
    setIsValid(Object.keys(newErrors).length === 0);
  };

  const handleChange = e => {
    const { name, value } = e.target;

    if (name === 'rfc' && clientType === 'Fisica' && value.length > 13) {
      return;
    }
    if (name === 'rfc' && clientType === 'Moral' && value.length > 12) {
      return;
    }

    setFormData({
      ...formData,
      [name]: value
    });
    setErrors({ ...errors, [name]: '' });
  };

  const handleClientTypeChange = e => {
    setClientType(e.target.value);
    setFormData({
      ...formData,
      rfc: '',
      typeinvoice: '',
      razonSocial: '',
      firstName: '',
      secondName: '',
      lastName: '',
      motherLastName: ''
    });
  };

  const handleSearch = async () => {
    if (isValid) {
      setLoading(true);
      const json = {
        rfc: formData.rfc,
        ...(clientType === 'Moral'
          ? { company_name: formData.razonSocial }
          : {
              customer_name:
                formData.firstName +
                ' ' +
                (formData.secondName !== '' ? formData.secondName + ' ' : '') +
                formData.lastName +
                ' ' +
                formData.motherLastName
            }),
        type: clientType,
        type_policy: formData.typeinvoice
      };
      try {
        await props.getCustomerRFC(props.clientToken, json);
        history.push('/cobranza/recibos');
      } catch (error) {
        if (error.response.data.error === 'RFC is not correct') {
          setOpenRFC(true);
        } else {
          setOpen(true);
        }
      } finally {
        setLoading(false);
      }
    }
  };
  const handleBackClick = () => {
    history.push('/cobranza/cliente');
  };
  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          width: '100vw',
          maxWidth: '1440px',
          padding: isMobile ? '60px 6% 100px' : '60px 150px 100px 100px',
          margin: '0 auto'
        }}
      >
        <div 
          style={{
            width: '100%',
            paddingRight: isMobile ? '0' : '40px',
            display: 'flex',
            flexDirection: 'column'
            }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div
              style={{
                width: '105px',
                display: 'flex',
                justifyContent: 'flex-start',
                gap: '5px',
                alignItems: 'center'
              }}
            >
              <IconButton onClick={() => handleBackClick()} style={{ paddingRight: 0 }}>
                <img src={FlechaIzquierda} />
              </IconButton>
              <span
                style={{
                  color: '#2D6DF6',
                  fontSize: '16px',
                  fontWeight: '500',
                  fontFamily: 'Sura Sans',
                  cursor: 'pointer'
                }}
                onClick={() => handleBackClick()}
              >
                Atrás
              </span>
            </div>
            <StepBullets 
              currentStep={1}
              steps={2}
              style={{
                position: isMobile ? 'absolute' : 'relative',
                left: isMobile ? '50%' : 'auto',
                transform: isMobile ? 'translateX(-50%)' : 'none',
                height: isMobile ? '40px' : 'auto'
              }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '83px',
                height: '40px',
                background: isValid ? '#E3E828' : '#CCCCCC',
                borderRadius: '28px',
                cursor: isValid ? 'pointer' : 'not-allowed',
                pointerEvents: isValid ? 'auto' : 'none'
              }}
              onClick={handleSearch}
            >
               {loading ? <Spinner /> : 'Buscar'} 
            </div>
          </div>
          <span style={{ fontSize: '26px' }}>1. Identifícate como cliente</span>
          <span style={{ fontSize: '16px', color: '#888B8D', marginTop: '1rem' }}>
            <CustomTooltip
              title={
                <div>
                  <img src={gifTooltip} alt="Descripción del GIF" style={{ width: '150px', height: 'auto' }} />
                </div>
              }
              placement="right"
              arrow
            >
              <span style={{ fontSize: '16px', color: '#888B8D', marginTop: '1rem', cursor: 'pointer' }}>
                Podrás identificar tu póliza con los siguientes datos
              </span>
            </CustomTooltip>
          </span>
          <RadioGroup row value={clientType} onChange={handleClientTypeChange} style={{ marginTop: '1rem' }}>
            <FormControlLabel
              value="Fisica"
              control={<Radio style={{ color: '#2D6DF6' }} />}
              label={<span>Física</span>}
            />
            <FormControlLabel
              value="Moral"
              control={<Radio style={{ color: '#2D6DF6' }} />}
              label={<span>Moral</span>}
            />
          </RadioGroup>
          <div style={{ display: 'flex', flexWrap: 'wrap', margin: isMobile ? '20px 0 40px' : '20px 0 0', gap: isMobile ? '14px 6px' : '0' }}>
            <FormControl error={!!errors.rfc} style={{ width: '48%', marginRight: isMobile ? '0' : '20px' }}>
              <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#2D6DF6' }}>
                Registro Federal de Contribuyentes (RFC){' '}
                <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#D12D35' }}>*</span>
              </span>
              <Input
                id="rfc"
                name="rfc"
                value={formData.rfc}
                onChange={handleChange}
                placeholder="Ingresa RFC"
                inputProps={{
                  style: {
                    fontFamily: 'Sura Sans'
                  },
                  maxLength: clientType === 'Fisica' ? 13 : 12
                }}
              />
              {errors.rfc && <FormHelperText>{errors.rfc}</FormHelperText>}
            </FormControl>
            <FormControl
              error={!!errors.typeinvoice}
              style={{
                width: '48%',
                display: isMobile ? 'flex' : 'inline-flex',
                justifyContent: isMobile ? 'flex-end' : 'none'
                }}
            >
              <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#2D6DF6' }}>
                Tipo Póliza <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#D12D35' }}>*</span>
              </span>
              <Select
                value={formData.typeinvoice}
                onChange={handleChange}
                inputProps={{
                  name: 'typeinvoice',
                  id: 'typeinvoice'
                }}
              >
                {props.catalog.map(item => (
                  <MenuItem key={item.product_id} value={item.product_id}>
                    {item.description}
                  </MenuItem>
                ))}
              </Select>
              {errors.typeinvoice && <FormHelperText>{errors.typeinvoice}</FormHelperText>}
            </FormControl>
            {clientType === 'Moral' && (
              <FormControl
                error={!!errors.razonSocial}
                style={{ width: '48%', marginTop: '10px', marginRight: isMobile ? '0' : '20px' }}
              >
                <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#2D6DF6' }}>
                  Razón Social <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#D12D35' }}>*</span>
                </span>
                <Input
                  id="razonSocial"
                  name="razonSocial"
                  value={formData.razonSocial}
                  onChange={handleChange}
                  placeholder="Ingresa la razón social"
                  inputProps={{
                    style: {
                      fontFamily: 'Sura Sans'
                    }
                  }}
                />
                {errors.razonSocial && <FormHelperText>{errors.razonSocial}</FormHelperText>}
              </FormControl>
            )}
            {clientType === 'Fisica' && (
              <React.Fragment>
                <FormControl
                  error={!!errors.firstName}
                  style={{ width: '48%', marginTop: '10px', marginRight: isMobile ? '0' : '20px' }}
                >
                  <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#2D6DF6' }}>
                    Primer nombre <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#D12D35' }}>*</span>
                  </span>
                  <Input
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Ingresa el nombre"
                    inputProps={{
                      style: {
                        fontFamily: 'Sura Sans'
                      }
                    }}
                  />
                  {errors.firstName && <FormHelperText>{errors.firstName}</FormHelperText>}
                </FormControl>
                <FormControl error={!!errors.secondName} style={{ width: '48%', marginTop: '10px' }}>
                  <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#2D6DF6' }}>Segundo nombre</span>
                  <Input
                    id="secondName"
                    name="secondName"
                    value={formData.secondName}
                    onChange={handleChange}
                    placeholder="Ingresa el segundo nombre"
                    inputProps={{
                      style: {
                        fontFamily: 'Sura Sans'
                      }
                    }}
                  />
                  {errors.secondName && <FormHelperText>{errors.secondName}</FormHelperText>}
                </FormControl>
                <FormControl error={!!errors.lastName} style={{ width: '48%', marginTop: '10px', marginRight: isMobile ? '0' : '20px' }}>
                  <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#2D6DF6' }}>
                    Apellido Paterno{' '}
                    <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#D12D35' }}>*</span>
                  </span>
                  <Input
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Ingresa el apellido paterno"
                    inputProps={{
                      style: {
                        fontFamily: 'Sura Sans'
                      }
                    }}
                  />
                  {errors.lastName && <FormHelperText>{errors.lastName}</FormHelperText>}
                </FormControl>
                <FormControl error={!!errors.motherLastName} style={{ width: '48%', marginTop: '10px' }}>
                  <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#2D6DF6' }}>
                    Apellido Materno{' '}
                    <span style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#D12D35' }}>*</span>
                  </span>
                  <Input
                    id="motherLastName"
                    name="motherLastName"
                    value={formData.motherLastName}
                    onChange={handleChange}
                    placeholder="Ingresa el apellido materno"
                    inputProps={{
                      style: {
                        fontFamily: 'Sura Sans'
                      }
                    }}
                  />
                  {errors.motherLastName && <FormHelperText>{errors.motherLastName}</FormHelperText>}
                </FormControl>
              </React.Fragment>
            )}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '264px',
            height: isMobile ? 'auto' : '464px',
            padding: '21px',
            background: '#FFFFFF',
            borderRadius: '20px',
            boxShadow: '0px 3px 6px #00000029'
          }}
        >
          <img
            src={iconClient}
            alt="Icono de cliente"
            style={{ width: '100px', height: '100px', alignSelf: 'center' }}
          />
          <span
            style={{
              fontSize: '26px',
              fontWeight: 500,
              color: '#2D6DF6',
              lineHeight: '22px',
              fontFamily: 'Sura Sans'
            }}
          >
            ¿No cuentas con la información necesaria?
          </span>
          <span style={{ fontSize: '16px', color: '#000000', marginTop: '20px', fontFamily: 'Sura Sans' }}>
            Comunícate con nosotros y un experto te ayudará.{' '}
          </span>
          <span style={{ fontSize: '16px', color: '#000000', marginTop: '20px', fontFamily: 'Sura Sans' }}>
            Tel.: 55 5723 7999
          </span>
        </div>
      </div>
      {open && <ModalUserNotFound setOpen={setOpen} open={open} resetForm={resetForm} />}
      {isMobile && <FooterMobile />}
      {!isMobile && <Footer />}
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  clientToken: state.clientReducer.clientToken,
  catalog: state.clientReducer.catalog
});

const mapDispatchToProps = {
  getClientsRFC,
  getCustomerRFC,
  persistDataPolicy,
  getClientsCatalog
};

export default connect(mapStateToProps, mapDispatchToProps)(IdentificateUser);



// WEBPACK FOOTER //
// ./src/containers/client/identificate/index.js